import baseStyles from '../Base/Base.styles';
import {parseResponsiveProperty, breakpointsMedia} from '@converdy/styles';

export default (props) => {
  let {base, distribution, columns, reverseOrder, gap} = props;

  const {
    desktopDistribution = '6,6',
    tabletDistribution = 'inherit',
    mobileDistribution = 'inherit',
  } = distribution;

  const desktop = desktopDistribution.split(',').join('fr ') + 'fr';
  const tablet =
    tabletDistribution === 'inherit'
      ? desktop
      : tabletDistribution.split(',').join('fr ') + 'fr';

  let mobile =
    mobileDistribution !== 'inherit'
      ? mobileDistribution.split(',').join('fr ') + 'fr'
      : tablet;

  let jss = {
    root: {
      ...baseStyles(base),
      '&': {
        ...parseResponsiveProperty((c) => ({gridGap: `${c}px`}), gap),
        gridTemplateColumns: desktop,
        '@media screen and (max-width: 768px)': {gridTemplateColumns: tablet},
        '@media screen and (max-width: 576px)': {gridTemplateColumns: mobile},
      },
    },
  };

  // We've got columns in two formats (bug)
  // [{...colSettings}, {...colSettings}]
  // And {0: {...colSettings}, 1:{...colSettings}}
  columns = Array.isArray(columns) ? columns : Object.values(columns);

  columns.forEach((column, index) => {
    column = column || {};

    let reversed = [5, 4, 3, 2, 1, 0];

    let desktopOrder, tabletOrder, mobileOrder;

    if (reverseOrder) {
      desktopOrder = reverseOrder.desktop ? reversed[index] : index;
      tabletOrder =
        typeof reverseOrder.tablet === 'undefined'
          ? desktopOrder
          : reverseOrder.tablet
          ? reversed[index]
          : index;
      mobileOrder =
        typeof reverseOrder.mobile === 'undefined'
          ? tabletOrder
          : reverseOrder.mobile
          ? reversed[index]
          : index;
    }

    /* If SSR, outside the editor */
    if (typeof window === 'undefined') {
      jss.root[`& > *:nth-child(${index + 1})`] = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: column.verticalAlignment,
        order: desktopOrder,
        [breakpointsMedia.tablet]: {
          order: tabletOrder,
        },
        [breakpointsMedia.mobile]: {
          order: mobileOrder,
        },
      };

      /* If in previewer */
    } else {
      jss.root[`& > div:nth-child(${index + 1})`] = {
        order: desktopOrder,
        [breakpointsMedia.tablet]: {
          order: tabletOrder,
        },
        [breakpointsMedia.mobile]: {
          order: mobileOrder,
        },
      };

      jss.root[`& > div.column:nth-child(${index + 1}) > div`] = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: column.verticalAlignment,
      };
    }
  });

  return jss;
};
